import { useIsLoggedIn } from '@order/AuthMachine';

import { useOrderStatusHasEarnedLoyaltyPointsQuery } from '../../graphql/OrderStatus.generated';

/**
 * Returns a boolean value for whether the customer has earned loyalty points for this order.
 */
export const useHasEarnedLoyaltyPoints = (orderId?: string) => {
  const isLoggedIn = useIsLoggedIn();

  const variables = { id: orderId ?? '' };
  const pause = !isLoggedIn || !orderId;

  const [{ data }] = useOrderStatusHasEarnedLoyaltyPointsQuery({
    pause,
    variables,
  });

  if (data?.orderStatus?.__typename === 'OrderStatus') {
    return data.orderStatus.order.hasEarnedLoyaltyPoints;
  }

  return false;
};
